

import settingIcon from "../Asset/Images/st.gif"

import logo from "../Asset/Images/logo (1).svg"


import user from "../Asset/Images/GN_ukOOW4AAT-qq.jpeg"

import userr from "../Asset/Images/user.jpg"

export const  assets = {

 
    settingIcon,
    logo,
    user,
    userr
    


}